/**
 * 公司介绍分段文案（结构参考 CompanyIntroduction-41.jpeg 长图）
 * 图源：https://resources.xycoder.com/dowa/CompanyIntroduction-41.jpeg
 * 若与原图措辞不一致，请对照该图修改本文件各段 title / paragraphs / list。
 */
export const COMPANY_INTRO_IMAGE_URL =
	'https://resources.xycoder.com/dowa/CompanyIntroduction-41.jpeg';

export const HOME_BROCHURE_SEGMENTS = [
	{
		id: 'brand',
		title: 'DOWA Metaltech',
		subtitle: '同和金属材料（上海）有限公司',
		paragraphs: [
			'作为 DOWA 集团金属加工事业的重要一环，我们面向中国及亚太地区客户提供高性能铜合金材料、技术支持与供应链服务。',
		],
	},
	{
		id: 'heritage',
		title: '集团事业背景',
		paragraphs: [
			'DOWA 金属加工事业始于铜及锌加工产品的制造，伴随汽车与电子设备的高功能化，事业拓展至以高性能铜合金为核心的产品群。',
			'在提升连接器用铜合金性能的同时，还提供多种电镀加工及用于功率模块的金属陶瓷基板等产品与服务。',
		],
	},
	{
		id: 'core',
		title: '伸铜品（加工铜产品）',
		paragraphs: [
			'在全球范围供应满足导电性、强度、耐热性、加工性等多样化需求的高特性铜合金，是连接器、引线框架等关键部件材料的重要来源。',
		],
		list: ['铜合金条材与压制品', '镍合金条材', '条材电镀', '黄铜锻造品'],
	},
	{
		id: 'plating',
		title: '电镀加工',
		paragraphs: [
			'面向车载电子等应用，开展贵金属、锡等多种电镀加工，提高产品耐久性与可靠性，并提供贵金属节约型工艺及海外加工服务。',
		],
	},
	{
		id: 'alloys',
		title: '主要合金体系',
		paragraphs: ['本网站产品目录涵盖以下代表性体系，可按应用需求进一步选型：'],
		list: ['铜合金', '钛铜', '铜镍硅', '黄铜', '纯铜'],
	},
	{
		id: 'markets',
		title: '应用行业',
		paragraphs: [
			'材料广泛应用于汽车电子、通信基础设备、工业机械、智能仪器及消费电子等领域，支撑连接器、散热与结构件等部件的可靠性设计。',
		],
	},
	{
		id: 'support',
		title: '技术支持',
		paragraphs: [
			'从材料选型、样品验证到量产导入，我们与客户共同优化合金牌号、规格与工艺窗口，并提供成分、机械性能及表面品质等方面的技术资料。',
		],
	},
	{
		id: 'network',
		title: '全球网络',
		paragraphs: [
			'DOWA 集团在亚洲多地设有制造与贸易据点。上海公司作为区域窗口，可协调集团内资源，满足跨国项目对材料规格统一与稳定交付的需求。',
		],
	},
];



// WEBPACK FOOTER //
// ./src/config/homeBrochureSegments.js